// extracted by mini-css-extract-plugin
export default {"root":"ImageControlButtons__root____h9DL"};